import { User } from '../models';
import { FrontPageState } from '../components';

export type QuestionGameVoteCallback = ((userId: number, type: QuestionGameVoteType) => void);

export enum QuestionGameVoteType {
    no,
    yes
}

export interface QuestionGameUser extends User {
    loading: boolean;
    gender?: number;
}

export interface QuestionGame {
    first: QuestionGameUser;
    second: QuestionGameUser;
}

export const defaultQuestionGame: QuestionGame = { first: { userId: 0, loading: true }, second: { userId: 0, loading: false } }

const updateUser = (state: FrontPageState, userType: string, user: QuestionGameUser): FrontPageState => {
    return {
        ...state,
        questionGame: {
            ...state.questionGame,
            [userType]: user,
        }
    };
};

export const questionGameUpdateFirst = (state: FrontPageState, user: QuestionGameUser) => updateUser(state, 'first', user);
export const questionGameUpdateSecond = (state: FrontPageState, user: QuestionGameUser) => updateUser(state, 'second', user);